const ARIA = {
    helpText: 'HelpTextAriaDescribedBy',
    error: 'ErrorAriaDescribedBy',
    optional: 'OptionalAriaDescribedBy',
    tooltip: 'TooltipAriaDescribedBy',
    euroSign: 'euroSignDescribedBy',
};

export { ARIA as A };
